window.NotificationService = class {
	isSwiping = false;
	mode = null;

	constructor() {
		const self = this;
		this.trigger = document.querySelector('#header [data-plugin="notification"]'); // aca tambien esta data-toggle="dropdown"
		if(this.trigger === null) {
			return;
		}
		this.container = document.querySelector('.notification-container');
		this.$trigger = $(this.trigger);
		const dropdownContainer = this.trigger.closest('.dropdown');

		this.$trigger.closest('.dropdown').on('show.bs.dropdown', (event) => {
			// Ejecutar fetch y hideBadge al abrir el dropdown
			this.fetch();
			// borra el badge en la UI. Del backend se encarga el servidor al traer desde fetch.
			this.hideBadge();
		});

		// Bind de los triggers - overrride
		// aca se capturan todos los triggers que queremos manejar en el dropdown.
		// por default va a prevenir la propagacion del evento.
		// si se quiere que se propague, se debe agregar el atributo data-allow-propagation="true"
		$('.dropdown-notification').on('click', '[data-trigger]', this.handleTriggerEvents );
	}

	handleTriggerEvents = async (event) => {

		const target = event.currentTarget;
		target.disabled = true;

		const dropdownInstance = this.$trigger.data('bs.dropdown');
		dropdownInstance.preventHide();

		let stopPropagation = true;
		let laddaButton = null;

		// Por default se hace un stop propagation
		// A menos que se defina el atributo data-allow-propagation
		// O que se haya disparado por el track event y no tenga un trigger
		if(target.dataset.allowPropagation !== undefined) {
			stopPropagation = false;
		}

		if(!target.dataset.style) {
			target.dataset.style = 'zoom-out';
		}

		// Si es tipo button inicializar Ladda
		if(target.tagName === 'BUTTON') {
			laddaButton = Ladda.create(target);
			laddaButton?.start();
		}

		try {
			switch(target.dataset.trigger) {

				case 'Post.validate':
					await Library.load(['PostComponent']);
					var post_id = target.dataset.post_id;
					var post_status = target.dataset.post_status;
					await PostComponent.validate(post_id, post_status);

					var wrapper = this.getWrapper(target);
					wrapper.querySelectorAll('[hide-on-published]')?.forEach(element => {
						element.remove();
					});

					break;

				case 'Post.send':
					await Library.load(['PostComponent']);
					var pub_id = target.dataset.pub_id;
					var post_id = target.dataset.post_id;

					await PostComponent.send(pub_id, post_id);

					// borrar notificacion
					var wrapper = this.getWrapper(target);
					this.delete(wrapper, 'click');

					break;

				case 'Post.delete':
					await Library.load(['PostComponent']);
					var post_id = target.dataset.post_id;
					var wrapper = this.getWrapper(target);
					await PostComponent.delete(post_id)
					this.delete(wrapper, 'click');

					break;

				//	Si ningun trigger matcheo, no hacer stopPropagation
				default:
					stopPropagation = false;
					break;
			}
		} catch (error) {
		} finally {

			dropdownInstance.allowHide();

			if(stopPropagation) {
				event.stopPropagation();
			}

			target.disabled = false;
			laddaButton?.stop();
		}

	}

	async fetch() {
		const self = this;
		const target = $('#notification-dropdown').find('.notification-container');

		this.showLoading();

		var response = await fetch(`/api/notifications`);
		response = await response.text();
		this.container.innerHTML = response;

		this.handleSwipe();
		this.handleMouse();

	}

	getWrapper(target) {
		return target.closest(".notification-wrapper");
	}

	async delete(wrapper, animation = "") {

		const self = this;
		const notification_web_id = wrapper.dataset.notification_web_id;
		const container = wrapper.querySelector('.notification-content');
		const swipeActions = wrapper.querySelector(".notification-swipe");
		let promises = [];

		try {
			// fijar la altura del elemento a la altura actual, para que la animacion de borrado sea mas suave.
			wrapper.style.height = `${wrapper.offsetHeight}px`;

			const axiosPromise = axios.delete(`/api/notification/${notification_web_id}`);

			if(animation == "click") {
				await Promise.all([
					self.updateTransform(container, { translateX: "-100%" }, "600ms ease", true),
					self.updateStyle(container, { opacity: 0 }, "200ms ease 300ms", true)
				]);
			} else if (animation == "swipe") {
				await Promise.all([
					self.updateStyle(swipeActions, { width: "100%", opacity: 1 }, true),
					self.updateTransform(container, { translateX: "-100%" }, true),
					self.updateStyle(wrapper, { opacity: 0 }, "150ms linear 100ms", true)
				]);
			}

			if ("vibrate" in navigator) {
				navigator.vibrate(30);
			}

			await axiosPromise;

			// esperar la animacion y remover el elemento del DOM
			await self.updateStyle(
				wrapper,
				{ height: "0px", marginBottom: "-5px" }, // el marginBottom compensa el gap que tiene el contenedor entre los elementos. Dado que el elemento no se borra, sino que le queda 0px de altura, se debe compensar el gap.
				"200ms linear", true
			);

			wrapper.remove();

		} catch (error) {
			// Revertir la animación si axios falla
			self.updateStyle(swipeActions, { width: "0", opacity: 0 });
			self.updateStyle(wrapper, { opacity: 1 });
			self.updateTransform(container, { translateX: 0 });
			self.updateStyle(container, { opacity: 1 });
			container.movement = 0;

		}

	}

	showLoading() {
		this.container.innerHTML = '<div class="text-center pb-20"><i class="fas fa-circle-notch fa-spin fa-2x" style="animation-duration: 1s; opacity: 0.5"></i></div>';
	}

	hideBadge() {
		document.querySelector('#header .badge-notification')?.remove();
	}

	handleSwipe() {
		const self = this;
		const dropdownInstance = self.$trigger.data('bs.dropdown');

		// Pixel tolerance to determine if task should be completed or deleted
		let tolerance = 200;

		const itemList = this.container.querySelectorAll('.notification-content');

		if (itemList.length)
			tolerance = itemList[0].offsetWidth / 2;

		// Function to add swipe functionality on given element
		itemList.forEach((elem, index) => {

			// fijar en 0 la posicion inicial
			elem.movement = 0;

			const wrapper = elem.closest(".notification-wrapper");
			const actions = wrapper.querySelector(".notification-swipe");

			const calculateOpacity = (px) => {
				const min = 50;
				const max = tolerance;
				if (px <= min) return 0;
				if (px > max) return 1;
				return (px - min) / (max - min);
			};

			// Function to delete the task
			const deleteSwipe = () => {
				self.delete(wrapper, 'swipe');
			};

			// Function to reset the swipe
			const actionSwipe = () => {
				elem.movement = -tolerance;
				self.updateTransform(elem, { translateX: `${elem.movement}px` });
				self.updateStyle(
					actions,
					{ width: "calc(50% - 5px)", opacity: 1 },
					"150ms linear"
				);
				elem.isMouseDown = false;
			};

			// Function to reset the swipe
			const resetSwipe = () => {
				elem.movement = 0;
				self.updateTransform(elem, { translateX: `${elem.movement}px` });
				self.updateStyle(actions, { width: "0px", opacity: 0 });
				elem.isMouseDown = false;
			};

			let framePending = false;
			// Function to handle mouse movement during swipe
			const handleMouseMove = (event) => {
				if (self.isSwiping) {
					// si esta haciendo el swipe, impedir el scroll.
					event.preventDefault();
				}

				if (!framePending || true) {
					framePending = true;
					requestAnimationFrame(() => {
						framePending = false;

						if (elem.isMouseDown) {
							const lastMovement = elem.movement;

							if (elem.touchStartX && event.touches) {
								const touchMoveX = event.touches[0].pageX;
								const touchMoveY = event.touches[0].pageY;

								// Calcula la diferencia en X y Y desde el inicio del toque
								const diffX = Math.abs(touchMoveX - elem.touchStartX);
								const diffY = Math.abs(touchMoveY - elem.touchStartY);

								// Previene el desplazamiento predeterminado si el movimiento es predominantemente horizontal
								if (diffX > diffY) {
									// event.preventDefault();
									self.isSwiping = true;
								}

								elem.movement =
									elem.startPosition + touchMoveX - elem.touchStartX;
							} else {
								elem.movement += event.movementX;
							}

							if (elem.movement < lastMovement) {
								elem.swipeDirection = "left";
							} else if (elem.movement > lastMovement) {
								elem.swipeDirection = "right";
							}

							// Apply classes based on swipe distance
							if (elem.movement > 0) {
								elem.swipeStage = "initial";
								self.updateStyle(actions, { width: `0px`, opacity: 0 }, false);
							} else if (elem.movement < -tolerance) {
								elem.swipeStage = "deleteThreshold";
								self.updateStyle(
									actions,
									{ width: `calc(${elem.movement * -1}px - 5px)`, opacity: 1 },
									false
								);
							} else {
								elem.swipeStage = "actionThreshold";
								self.updateStyle(
									actions,
									{
										width: `calc(${elem.movement * -1}px - 5px)`,
										opacity: calculateOpacity(elem.movement * -1),
									},
									false
								);
							}

							// Move the element based on swipe distance
							self.updateTransform(
								elem,
								{ translateX: `${elem.movement}px` },
								false
							);
						}
					});
				}
			};

			// Function to handle when mouse leaves the element
			const handleMouseOut = (event) => {
				resetSwipe();
				elem.touchStartX = null;
				document.removeEventListener("mousemove", handleMouseMove);
				document.removeEventListener("touchmove", handleMouseMove);
			};

			// Function to handle end of swipe
			const handleMouseUp = async (event) => {

				if (!elem.isMouseDown) {
					return;
				}

				event.preventDefault();

				elem.isMouseDown = false;
				self.isSwiping = false;

				document.removeEventListener("mouseup", handleMouseUp);
				document.removeEventListener("mousemove", handleMouseMove);
				document.removeEventListener("touchmove", handleMouseMove);

				if (elem.swipeDirection == "left" && Math.abs(elem.movement) > 20) {
					if (elem.swipeStage == "deleteThreshold") deleteSwipe();
					else if (elem.swipeStage == "actionThreshold") actionSwipe();
					else resetSwipe();
				} else if (
					elem.swipeDirection == "right" &&
					Math.abs(elem.movement) > 20
				) {
					if (elem.swipeStage == "deleteThreshold") actionSwipe();
					else if (elem.swipeStage == "actionThreshold") resetSwipe();
					else resetSwipe();
				} else resetSwipe();

				// hack que permite que el evento click se dispare en el bootstrap/dropdown
				await UtilityHelper.sleep(0);
				// luego de ejecutado ese evento, permitimos nuevamente que se cierre el dropdown.
				dropdownInstance.allowHide();
			};

			// Function to handle start of swipe
			const handleMouseDown = async (event) => {

				if (event.currentTarget?.tagName?.toLowerCase() === 'button') {
					return;
				}
				if (event.currentTarget?.dataset.action || event.currentTarget?.dataset.trigger || event.currentTarget?.dataset.track) {
					return;
				}

				// prevent right click
				if (event.button === 2) {
					event.preventDefault();
					event.stopPropagation();
					return;
				}

				elem.isMouseDown = true;
				elem.swipeStage = elem.swipeStage || "initial";
				elem.swipeDirection = "none";
				elem.startPosition = elem.movement;
				dropdownInstance.preventHide();

				// Las animaciones atadas a un swipe no deben llevar transiciones.
				// Resetear las transiciones pasando undefined como value
				self.updateTransition(actions, "opacity");
				self.updateTransition(actions, "width");
				self.updateTransition(elem, "transform");

				if (event.touches) {
					elem.touchStartX = event.touches[0].pageX;
					elem.touchStartY = event.touches[0].pageY;
				}

				document.addEventListener("mousemove", handleMouseMove);
				document.addEventListener("touchmove", handleMouseMove, {
					passive: false,
				}); // habilito el uso de preventDefault
				document.addEventListener("mouseup", handleMouseUp);
			};

			// Adding all necessary event listeners to the given element
			elem.addEventListener("touchstart", handleMouseDown);
			elem.addEventListener("touchend", handleMouseUp);
			elem.addEventListener("mousedown", handleMouseDown);

			elem.addEventListener(
				"click",
				(event) => {

					console.log(event);

					if (event.currentTarget.tagName?.toLowerCase() === 'button') {
						return;
					}
					if (event.currentTarget.dataset?.action || event.currentTarget.dataset?.trigger || event.currentTarget.dataset?.track) {
						return;
					}
					if (event.button === 2) {
						event.preventDefault();
						event.stopPropagation();
					}

					event.preventDefault();

				},
				false
			);

			elem.addEventListener("contextmenu", (event) => {
				event.preventDefault();
			});

			wrapper
				.querySelector("[data-action='touch-delete']")
				?.addEventListener("click", deleteSwipe);

			elem.addEventListener("mouseup", handleMouseUp);
		});
	}

	handleMouse() {
		const self = this;
		const itemList = this.container.querySelectorAll('.notification-content');

		itemList.forEach((container, index) => {

			const wrapper = container.closest(".notification-wrapper");

			container
				.querySelector("[data-action='click-delete']")
				?.addEventListener("click", (event) => {
					console.log(event);
					self.delete(wrapper, 'click');
				});
		});
	}

	updateTransition(element, property, value = null) {
		// Inicializa o recupera el registro de transiciones almacenado directamente en el elemento
		if (!element._transitions) {
			element._transitions = {};
		}

		if (value === null || value === "") {
			// Elimina la transición si el valor es 'null' o una cadena vacía
			delete element._transitions[property];
		} else {
			// Actualiza o añade la nueva transición
			element._transitions[property] = value;
		}

		// Reconstruye la cadena de transiciones a partir del objeto de transiciones y la aplica al elemento
		const transitionsArray = Object.entries(element._transitions).map(
			([key, val]) => `${key} ${val}`
		);

		element.style.transition = transitionsArray.join(", ");
	}

	generateNamespace() {
		return `ns_${Math.random().toString(36).substr(2, 9)}`;
	}

	updateStyle(element, styles, transition = "150ms linear", returnPromise = false) {
		const self = this;
		const namespace = self.generateNamespace();

		if (transition !== false) {
			Object.keys(styles).forEach((property) => {
				self.updateTransition(element, property, transition);
			});
		}

		const promise = new Promise((resolve) => {
			const handleTransitionEnd = (event) => {
				if (Object.keys(styles).includes(event.originalEvent.propertyName)) {
					$(element).off(`transitionend.${namespace}`, handleTransitionEnd);
					resolve();
				}
			};

			if (returnPromise) {
				$(element).on(`transitionend.${namespace}`, handleTransitionEnd);
			}

			requestAnimationFrame(() => {
				Object.keys(styles).forEach((property) => {
					if (property == "transform") {
						self.updateTransform(element, styles[property], false);
					} else {
						element.style[property] = styles[property];
					}
				});
			});
		});

		return returnPromise ? promise : undefined;
	}

	updateTransform(element, transformsObj, transition = "150ms linear", returnPromise = false) {
		const self = this;
		const namespace = self.generateNamespace();

		if (transition !== false) {
			self.updateTransition(element, "transform", transition);
		}

		const promise = new Promise((resolve) => {
			const handleTransitionEnd = (event) => {
				if (event.originalEvent.propertyName === "transform") {
					$(element).off(`transitionend.${namespace}`, handleTransitionEnd);
					resolve();
				}
			};

			if (returnPromise) {
				$(element).on(`transitionend.${namespace}`, handleTransitionEnd);
			}

			requestAnimationFrame(() => {
				element.transform = Object.assign({}, element.transform || [], transformsObj);
				const transformValues = Object.entries(element.transform).map(
					([transformName, value]) => `${transformName}(${value})`
				);
				element.style.transform = transformValues.join(" ");
			});
		});

		return returnPromise ? promise : undefined;
	}

	// Obtiene los valores de BoundingRect sin su transformacion.
	untransformedBoundingRect(element) {
		var rect = element.getBoundingClientRect();
		var style = getComputedStyle(element);
		var tx = style.transform;

		if (tx) {
			var sx, sy, dx, dy;
			if (tx.startsWith("matrix3d(")) {
				var ta = tx.slice(9, -1).split(/, /);
				sx = +ta[0];
				sy = +ta[5];
				dx = +ta[12];
				dy = +ta[13];
			} else if (tx.startsWith("matrix(")) {
				var ta = tx.slice(7, -1).split(/, /);
				sx = +ta[0];
				sy = +ta[3];
				dx = +ta[4];
				dy = +ta[5];
			} else {
				return rect;
			}

			var to = style.transformOrigin;
			var x = rect.x - dx - (1 - sx) * parseFloat(to);
			var y =
				rect.y - dy - (1 - sy) * parseFloat(to.slice(to.indexOf(" ") + 1));
			var w = sx ? rect.width / sx : element.offsetWidth;
			var h = sy ? rect.height / sy : element.offsetHeight;
			return {
				x: x,
				y: y,
				width: w,
				height: h,
				top: y,
				right: x + w,
				bottom: y + h,
				left: x,
			};
		} else {
			return rect;
		}
	}

	applyZIndex() {
		const self = this;

		this.notificationWrappers.forEach((item, index) => {
			item.style.zIndex = self.notificationWrappers.length - index;
		});
	}
	//
	// stackMode(transition = "150ms linear") {
	// 	const self = this;
	// 	self.mode = "stack";
	//
	// 	const containerPadding = 10;
	//
	// 	if (this.notificationWrappers.length > 0) {
	// 		this.notificationWrappers[0].classList.add('stacked-visible');
	// 		const topHeight = this.notificationWrappers[0].offsetHeight;
	//
	// 		this.notificationWrappers.forEach((wrapper, index) => {
	// 			const height = wrapper.offsetHeight;
	// 			//obtener distancia del elemento a la parte superior del contenedor
	// 			const distanceTop = wrapper.offsetTop - containerPadding - (topHeight - height);
	//
	// 			if (index > 0) {
	// 				self.updateStyle(wrapper, {pointerEvents: "none"}, null);
	// 			} else {
	// 				self.updateStyle(wrapper, {pointerEvents: null, opacity: 1}, null);
	// 			}
	//
	// 			if (index > 2) {
	// 				self.updateStyle(
	// 					wrapper,
	// 					{
	// 						opacity: 0,
	// 						transform: {
	// 							translate3d: `0,-${distanceTop - index * 10}px,0`,
	// 							scale3d: `${Math.pow(0.95, index)}, ${Math.pow(0.95, index)}, 1`,
	// 						},
	// 					},
	// 					transition
	// 				);
	// 			} else if (index > 0) {
	// 				self.updateStyle(
	// 					wrapper,
	// 					{
	// 						// opacity: Math.pow(0.95, index),
	// 						transform: {
	// 							translate3d: `0,-${distanceTop - index * 10}px,0`,
	// 							scale3d: `${Math.pow(0.95, index)}, ${Math.pow(0.95, index)}, 1`,
	// 						},
	// 						filter: `brightness(${Math.pow(0.95, index)})`,
	// 						opacity: 1,
	// 					},
	// 					transition
	// 				);
	// 			} else {
	// 				self.updateStyle(
	// 					wrapper,
	// 					{
	// 						transform: {
	// 							translate3d: `0,-${distanceTop - index * 10}px,0`,
	// 							scale3d: `${Math.pow(0.95, index)}, ${Math.pow(0.95, index)}, 1`,
	// 						},
	// 						filter: 'brightness(1)',
	// 						opacity: 1,
	// 					},
	// 					transition
	// 				);
	// 			}
	// 		});
	// 	} else {
	// 		console.debug("no hay notificaciones");
	// 		// set div height to 0
	// 		self.notificationPanel.style.height = "0px";
	// 	}
	//
	// 	// setTimeout(() => {
	// 	// 	this.scrollMode();
	// 	// }, 2000);
	// }
	//
	// scrollMode() {
	// 	const self = this;
	// 	self.mode = "scroll";
	// 	self.notificationContainer.dataset.stacked = false;
	//
	// 	// mobile: entre otras cosas, deshabilita el scroll en body
	// 	document.body.classList.add("notification-scrollmode");
	//
	// 	// habilitar los pointer events en todos los elementos.
	// 	// si venia de estar stacked, salvo el 1ro, los demas estaban deshabilitados.
	// 	for (const wrapper of self.notificationWrappers) {
	// 		self.updateStyle(wrapper, { pointerEvents: null }, null);
	// 	}
	//
	// 	// mobile only.
	// 	setTimeout(() => {
	// 		this.notificationContainer.scrollIntoView({ behavior: "smooth" });
	// 	}, 100);
	//
	// 	// a veces no queda perfectamente alineado con el scrollintoview anterior, con esto nos aseguramos.
	// 	setTimeout(() => {
	// 		this.notificationContainer.scrollIntoView();
	// 	}, 800);
	//
	// 	let frame;
	// 	let isScrollingTimer;
	//
	// 	this.notificationContainer.addEventListener(
	// 		"scroll",
	// 		function (event) {
	// 			if (!self.isScrolling) {
	// 				// Al scrollear, previene que se pueda disparar un swipe de una notificacion.
	// 				self.notificationContents.forEach((notification, index) => {
	// 					notification.isMouseDown = false;
	// 				});
	// 				self.isScrolling = true;
	// 			}
	//
	// 			if (!frame) {
	// 				frame = requestAnimationFrame(() => {
	// 					self.applyScrollEffect();
	// 					frame = null;
	//
	// 					// Limpia el temporizador previo para reiniciar el contador
	// 					window.clearTimeout(isScrollingTimer);
	//
	// 					// Establece un nuevo temporizador
	// 					isScrollingTimer = setTimeout(() => {
	// 						self.isScrolling = false;
	// 					}, 100);
	// 				});
	// 			}
	// 		},
	// 		{ passive: true }
	// 	);
	//
	// 	self.applyScrollEffect("500ms ease");
	// }
};